"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var emailAddressRegex = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
var emailAddressValidator = function (value) {
    if (typeof value !== 'string') {
        return false;
    }
    return value.search(emailAddressRegex) >= 0;
};
exports.default = emailAddressValidator;
